export default {
  getAll: {
    url: '/api/outcategory/getAll',
    method: 'get'
  },
  create: {
    url: '/api/outcategory/create',
    method: 'post'
  },
  update: {
    url: '/api/outcategory/update',
    method: 'put'
  },
  delete: {
    url: '/api/outcategory/delete',
    method: 'delete'
  }
}



// WEBPACK FOOTER //
// ./src/api/outcategory.js